import http from '@http';

class KindergartenModuleService {
    getModules(kindergartenId) {
        return http.get(`/api/kindergartens/${kindergartenId}/modules`).then(res => res.data);
    }

    updateModules(kindergartenId, data) {
        return http.put(`/api/kindergartens/${kindergartenId}/modules`, data).then(res => res.data);
    }
}

export default new KindergartenModuleService();
